import { render } from "./DashboardForm.vue?vue&type=template&id=8c39e9f4"
import script from "./DashboardForm.vue?vue&type=script&lang=js"
export * from "./DashboardForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__